// ⬡B:ms_mac_core.Shell:CODE:ms_mac_persona_clone_fix:20260607⬡
// Ms.Ria glass panel shell. Extracted from apps/msria-home/src/App.jsx.
// Includes GlassStyles (global CSS vars) + the wrap/smoke/panel structure.
import React from 'react';

function GlassStyles() {
  return (
    <style>{`
      :root{
        --ink:#08080a;--glass:rgba(255,255,255,.055);--hair:rgba(214,217,224,.26);
        --platinum:#e9ebf0;--rose:#e8b4a0;--rosed:#c98d76;--bronze:#b08d57;
        --burg:#5e2230;--gold:#c9a24a;--text:#f3f2ef;--muted:#b9bcc6;
      }
      *{box-sizing:border-box}
      html,body,#root{height:100%}
      body{margin:0;background:var(--ink);color:var(--text);
        font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,system-ui,sans-serif;
        -webkit-font-smoothing:antialiased;overflow-x:hidden}
      .smoke{position:fixed;inset:-25%;z-index:0;pointer-events:none;
        background:
          radial-gradient(38% 32% at 28% 30%,rgba(232,150,170,.24),transparent 70%),
          radial-gradient(42% 38% at 74% 38%,rgba(176,108,120,.18),transparent 72%),
          radial-gradient(48% 44% at 52% 80%,rgba(94,34,48,.34),transparent 76%),
          radial-gradient(70% 60% at 50% 50%,rgba(18,14,20,.85),#07070a 82%);
        filter:blur(10px);animation:burns 52s ease-in-out infinite alternate}
      @keyframes burns{0%{transform:scale(1.06) translate(0,0)}50%{transform:scale(1.2) translate(-2.5%,-1.5%)}100%{transform:scale(1.12) translate(2%,1.2%)}}
      @media(prefers-reduced-motion:reduce){.smoke{animation:none;transform:scale(1.1)}}
      .wrap{position:relative;z-index:1;min-height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:36px 22px;text-align:center}
      .panel{width:100%;max-width:470px;background:var(--glass);border:1px solid var(--hair);border-radius:24px;backdrop-filter:blur(24px) saturate(120%);-webkit-backdrop-filter:blur(24px) saturate(120%);padding:42px 28px;box-shadow:0 34px 90px rgba(0,0,0,.5)}
      .name{font-size:48px;font-weight:600;letter-spacing:.4px;margin:0;color:var(--platinum);text-shadow:0 0 30px rgba(232,150,170,.38)}
      .name .dot{color:var(--rose)}
      .tag{margin:20px 4px 0;font-size:17px;line-height:1.55;color:var(--muted);font-weight:400}
      .cta{margin-top:32px;display:inline-flex;align-items:center;gap:10px;padding:16px 26px;border-radius:999px;border:1px solid var(--hair);background:linear-gradient(135deg,rgba(232,150,170,.18),rgba(176,141,87,.16));color:var(--platinum);font-size:16px;font-weight:600;cursor:pointer;width:100%;justify-content:center;box-shadow:0 0 0 1px rgba(232,150,170,.10),0 16px 34px rgba(0,0,0,.4);transition:transform .12s ease}
      .cta:active{transform:translateY(1px)}
      .cta:disabled{opacity:.6;cursor:default}
      .ghost{margin-top:13px;background:rgba(0,0,0,.18);border:1px solid var(--hair);color:var(--muted);padding:14px;border-radius:14px;width:100%;cursor:pointer;font-size:15px}
      .ghost:disabled{opacity:.5;cursor:default}
      .sub{margin-top:20px;font-size:13px;color:var(--muted)}
      .sub a{color:var(--rose);text-decoration:none}
      .lede{font-size:19px;line-height:1.6;color:var(--text);margin:0 0 18px;font-weight:500}
      .body{font-size:16px;line-height:1.72;color:var(--muted);margin:0 0 14px;text-align:left}
      .field{width:100%;margin-top:14px;padding:14px 16px;border-radius:13px;border:1px solid var(--hair);background:rgba(0,0,0,.28);color:var(--text);font-size:15px;outline:none}
      .field:focus{border-color:var(--rosed)}
      .back{display:inline-block;margin-top:24px;color:var(--rose);text-decoration:none;font-size:14px}
      .note{margin-top:16px;font-size:13px;color:var(--muted);line-height:1.5}
    `}</style>
  );
}

export function Shell({ children }) {
  return (
    <div className="wrap">
      <GlassStyles />
      <div className="smoke" />
      <div className="panel">{children}</div>
    </div>
  );
}
